import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastModule as PrimeToast } from 'primeng/toast';
import { RxIconModule } from '../../icon-legacy/icon.module'

@Component({
  selector: 'rx-applications-toast',
  templateUrl: './toast.component.html',
  standalone: true,
  imports: [CommonModule, RxIconModule, PrimeToast],
})
export class ToastComponent {
  readonly position = 'top-center';
  readonly hideTransitionOptions = '100ms';
  readonly showTransformOptions = 'translateY(-100%)';
}
